<div class="layout-default">
    <div style="background-color: #1E88E5; flex: 1;"></div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-15.html